import React from 'react'

const statusConfig = {
  ongoing:        { label: 'Human at Work',            className: 'badge-ongoing',        dot: '●' },
  submitted:      { label: 'In Review',                className: 'badge-pending',        dot: '●' },
  pending:        { label: 'In Review',                className: 'badge-pending',        dot: '●' },
  needs_evidence: { label: 'More Evidence Needed',     className: 'badge-needs-evidence', dot: '◆' },
  verified:       { label: 'Human Origin Confirmed',   className: 'badge-verified',       dot: '✓' },
  rejected:       { label: 'Not Verified',             className: 'badge-rejected',       dot: '✕' },
}

export default function StatusBadge({ status, large = false }) {
  const config = statusConfig[status] || statusConfig.pending
  return (
    <span className={`badge ${config.className}`} style={large ? { fontSize: 14, padding: '8px 20px' } : {}}>
      <span>{config.dot}</span>
      {config.label}
    </span>
  )
}
